import React from 'react';
import { HiCheckCircle } from 'react-icons/hi';

const WhyJoinSection = () => {
  return (
    <section className="bg-white section-wrapper">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center">
        {/* Text Block */}
        <div>
          <h3 className="text-3xl font-bold text-primary mb-4">
            Why Join the BetterTurns Co-op?
          </h3>
          <p className="text-gray-700 text-lg mb-6">
            BetterTurns is more than a platform — it’s a grassroots alliance of
            independent retailers working smarter, together. We offer tools,
            insights, and collective strength that help you grow sustainably
            without going it alone.
          </p>

          <ul className="space-y-3">
            {[
              'Access shared analytics and market trends',
              'Collaborate on inventory planning and replenishment',
              'Gain buying power through collective sourcing',
              'Learn from others and grow stronger together',
            ].map((item, index) => (
              <li
                key={index}
                className="flex items-start text-gray-700 text-base"
              >
                <HiCheckCircle className="text-spring-green mt-1 mr-2" />
                {item}
              </li>
            ))}
          </ul>

          <div className="mt-6">
            <a
              href="mailto:join@betterturns.com"
              className="inline-block bg-sunshine-yellow text-deep-navy px-6 py-3 rounded font-semibold shadow hover:bg-warm-orange transition"
            >
              Join the Co-op
            </a>
          </div>
        </div>

        {/* Image */}
        <div>
          <img
            src="/images/graph.png"
            alt="Join the Co-op"
            className="rounded-lg shadow-lg w-full h-auto object-cover"
          />
        </div>
      </div>
    </section>
  );
};

export default WhyJoinSection;
